import { Injectable } from '@angular/core';
import { VernostServiceService } from './vernost-service.service';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  arrayId: any;
  passanger_details: any;
  Charge_Details: any;
  Note_details: any;
  constructor(private vernostService: VernostServiceService) { }

  checkColor(approveStatus, componentName) {
    if (approveStatus == 0) {

      (document.getElementById("btnname") as HTMLInputElement).value = "Inactive";
      document.getElementById("btnname").style.background = "gray";

    } else {

      (document.getElementById("btnname") as HTMLInputElement).value = "Active";

      if (componentName == 'airline-master' || componentName == 'airport-master' ||
        componentName == 'currency-master' || componentName == 'country-master' ||
        componentName == 'rate-per-mile' || componentName == 'airline-exclusion' ||
        componentName == 'banner-master' || componentName == 'charge-master' ||
        componentName == 'fare-rules-master' || componentName == 'tax-master') {
        document.getElementById("btnname").style.background = "green";
      }

      if (componentName == 'fare-product' ||
        componentName == 'city-master' ||
        componentName == 'ancellaries-description') {
        document.getElementById("btnname").style.background = "rgb(40, 169, 224)";
      }

    }
  }


  gotochangestatus(actionmode, otherInfo) {
    document.getElementById("errs").innerHTML = "";
    if (actionmode == "Edit") {
      let dataFareProduct = {
        parent_table: otherInfo[0],
        formData: otherInfo[1],
        columnName: otherInfo[2]
      };
      return dataFareProduct;
    }
  }



  openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    document.getElementById("" + cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }

  numcheck(startrange, id, regex) {
    let validflagform = false;
    if (regex.test(startrange) == false) {

      validflagform = false;
      document.getElementById(id + "_err").innerHTML = " *Only Numbers are accepted"
      if (startrange == "") {
        document.getElementById(id + "_err").innerHTML = "";
      }
    }
    else {
      validflagform = true;
      document.getElementById(id + "_err").innerHTML = ""
    }
    return validflagform;
  }

  blankcheck(name, id) {
    let validflagform = false;
    if (name == "") {
      validflagform = false;
      document.getElementById(id + "_err").innerHTML = " *Please select an option"
    }
    else {
      validflagform = true;
      document.getElementById(id + "_err").innerHTML = ""
    }

    return validflagform;
  }

  checkLimit(id, min, max, value, validflagform) {

    if (validflagform === true) {
      if (value <= min || (value > max && max != undefined)) {
        validflagform = false;
        document.getElementById(id + "_err").innerHTML = " * Please enter valid value"
      }
    }
    return validflagform;
  }

  validation(validationField, regex, JPNo) {
    let flag = false;
    switch (validationField) {
      case 'fname':
        if (JPNo != "" && regex.test(JPNo) == false) {
          document.getElementById("fnErr").innerHTML = "Only Alphabets allowed";
          document.getElementById("fnErr").style.color = "red";
          flag = true;
        } else {
          document.getElementById("fnErr").innerHTML = "";
          flag = false;
        }
        return flag;

      case 'lname':
        if (JPNo != "" && regex.test(JPNo) == false) {
          document.getElementById("lnErr").innerHTML = "Only Alphabets allowed";
          document.getElementById("lnErr").style.color = "red";
          flag = true;
        } else {
          document.getElementById("lnErr").innerHTML = "";
          flag = false;
        }
        return flag;

      case 'orderValidation':
        if (JPNo != "" && regex.test(JPNo) == false) {
          document.getElementById("orErr").innerHTML =
            "Only Alphabets and Numbers allowed";
          document.getElementById("orErr").style.color = "red";
          flag = true;
        } else {
          document.getElementById("orErr").innerHTML = "";
          flag = false;
        }
        return flag;

      case 'orderValidation1':
        if (JPNo.length > 0) {
          if (JPNo.length < 14) {
            document.getElementById("orErr").innerHTML =
              "Please enter 18 digit Booking Reference No ";
            document.getElementById("orErr").style.color = "red";
            flag = true;
          } else {
            document.getElementById("orErr").innerHTML = "";
            flag = false;
          }
        }
        return flag;

      case 'pnrValidation':
        if (JPNo != "" && regex.test(JPNo) == false) {
          document.getElementById("pnrNO").innerHTML =
            "Only Alphabets and Numbers allowed";
          document.getElementById("pnrNO").style.color = "red";
          flag = true;
        } else {
          document.getElementById("pnrNO").innerHTML = "";
          flag = false;
        }
        return flag;

      case 'pnrValidation1':
        if (JPNo.length > 0) {
          if (JPNo.length < 6) {
            document.getElementById("pnrNO").innerHTML =
              "Please enter 6 digit PNR No ";
            document.getElementById("pnrNO").style.color = "red";
            flag = true;
          } else {
            document.getElementById("pnrNO").innerHTML = "";
            flag = false;
          }
        }
        return flag;

      case 'jpnumbervalidation':
        if (JPNo != "" && regex.test(JPNo) == false) {
          document.getElementById("JpErr").innerHTML =
            "Only Alphabets and Numbers allowed";
          document.getElementById("JpErr").style.color = "red";
          flag = true;
        } else {
          document.getElementById("JpErr").innerHTML = "";
          flag = false;
        }
        return flag;

      case 'jpnumbervalidation1':
        if (JPNo.length > 0) {
          if (JPNo.length < 9) {
            document.getElementById("JpErr").innerHTML =
              "Please enter the correct JP number.";
            document.getElementById("JpErr").style.color = "red";
            flag = true;
          } else {
            document.getElementById("JpErr").innerHTML = "";
            flag = false;
          }
        }
        return flag;

      case 'cr-jpnumbervalidation':
        if (JPNo != "" && regex.test(JPNo) == false) {
          document.getElementById('JpErr').innerHTML = "Allows Integers only";
          document.getElementById('JpErr').style.color = "red";
          flag = true;
        } else {
          document.getElementById('JpErr').innerHTML = "";
          flag = false;
        }
        return flag;

      case 'ticketvalidation':
        // if (JPNo != "" && regex.test(JPNo) == false) {
        //   // document.getElementById("JpErr").innerHTML =
        //   //   "";
        //   // document.getElementById("JpErr").style.color = "red";
        //   flag = true;
        // } else {
        //   document.getElementById("JpErr").innerHTML = "";
        //   flag = false;
        // }
        if (JPNo.length <= 0) {
          flag = true;
        } else {
          flag = false;
        }
        return flag;

      case 'ticketvalidation1':
        if (JPNo.length > 0) {
          if (JPNo.length < 9) {
            // document.getElementById("JpErr").innerHTML =
            //   "Please enter 9 digit JP Number";
            // document.getElementById("JpErr").style.color = "red";
            flag = true;
          } else {
            document.getElementById("JpErr").innerHTML = "";
            flag = false;
          }
        }
        return flag;

      default:
        return flag;
    }
  }

  openNav(id) {
    this.arrayId = "NA";
    this.passanger_details = {
      id: "",
      Paxtype: "Select",
      title: "Select Title",
      firstName: "",
      lastName: "",
      email: "",
      mobile: ""
    };
    this.Charge_Details = {
      Remarks: "",
      amount: "",
      chargeApply: "",
      chargeDesc: "",
      chargeType: "",
      currency: "Select",
      createdDate: null
    };
    this.Note_details = {
      id: "",
      noteText: "",
      createdDate: null
    };
    document.getElementById(id).style.width = "90%";
    document.getElementById(id + "head").style.width = "100%";

    return [{ "arrayId": this.arrayId, "passanger_details": this.passanger_details, "Charge_Details": this.Charge_Details, "Note_details": this.Note_details }]
  }


  closeNav(id) {
    document.getElementById(id).style.width = "0%";
    document.getElementById(id + "head").style.width = "0%";
  }

  increaseDate() {
    var tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    var tam = new Date(tomorrow);
    let final = tam.setDate(tam.getDate());
    return final;
  }


}



